module.exports = __webpack_public_path__ + "img/top-logo@2x.9b834fa8.png";